"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Table = _interopRequireDefault(require("../table/Table"));

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("../button-control"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var List = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(List, _Component);

  var _super = _createSuper(List);

  function List(props) {
    var _this;

    (0, _classCallCheck2.default)(this, List);
    _this = _super.call(this, props);
    _this.state = {
      clientToDelete: null
    };
    return _this;
  }

  (0, _createClass2.default)(List, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          clients = _this$props.clients,
          onRevokeButtonClick = _this$props.onRevokeButtonClick;
      var clientToDelete = this.state.clientToDelete;
      var model = [{
        header: 'Label',
        accessor: 'label'
      }, {
        header: 'Client ID',
        accessor: 'client_id'
      }, {
        header: 'Created at',
        accessor: 'created_at'
      }, {
        header: 'Action',
        accessor: 'action'
      }];
      var rows = clients.map(function (client) {
        return {
          label: client.name,
          client_id: client.clientId,
          created_at: client.createdAt,
          action: (0, _preact.h)(_buttonControl.default, {
            class: "qa-delete-client",
            newStyle: true,
            title: "Delete",
            variant: "warning",
            onClick: function onClick() {
              return _this2.setState({
                clientToDelete: client
              });
            }
          })
        };
      });
      return (0, _preact.h)("div", {
        className: "oauth2-clients-list"
      }, (0, _preact.h)("h4", {
        className: "header-title"
      }, "Generated OAuth2 Clients"), (0, _preact.h)(_Table.default, {
        model: model,
        rows: rows,
        narrow: true
      }), (0, _preact.h)(_Modal.Modal, {
        isOpen: clientToDelete != null
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Delete this client?",
        onClose: function onClose() {
          return _this2.setState({
            clientToDelete: null
          });
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, "If you delete this client, it's gone for good."), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        title: "Delete",
        variant: "warning",
        class: "qa-confirm-delete-client",
        onClick: function onClick() {
          return _this2.setState({
            clientToDelete: null
          }, onRevokeButtonClick(clientToDelete));
        }
      }), (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        title: "Cancel",
        class: "qa-cancel-delete-client",
        onClick: function onClick() {
          return _this2.setState({
            clientToDelete: null
          });
        }
      }))));
    }
  }]);
  return List;
}(_preact.Component);

var _default = List;
exports.default = _default;